import logo from "../assets/logo_h.svg"

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-white to-purple-50 pt-16 pb-8 font-satoshi">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top Row */}
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          {/* Left - Logo + Description + Copyright */}
          <div className="max-w-sm">
            {/* Logo */}
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="Resolut" className="h-8 w-auto" />
              <span className="text-xl font-[500] text-gray-900 font-satoshi">
                Resolut
              </span>
            </div>

            {/* Description */}
            <p className="text-gray-500 text-sm leading-relaxed font-fustat mb-6">
              We're building the future of hiring with Resolut. Our AI agents
              can shortlist and interview candidates on autopilot, saving your
              team crucial time. We provide tools to manage candidate
              communication, conduct interviews, and collect feedback, all in
              one place.
            </p>

            {/* Copyright */}
            <p className="text-gray-400 text-xs font-fustat">
              © 2025 Resolut Tech Pvt Ltd All rights reserved.
            </p>
          </div>

          {/* Right - Nav Columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
            {/* Resources */}
            <div>
              <h4 className="text-gray-900 text-sm font-[600] mb-4 font-satoshi">
                Resources
              </h4>
              <ul className="space-y-3">
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Case Studies
                  </button>
                </li>
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Blogs
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-gray-900 text-sm font-[600] mb-4 font-satoshi">
                Contact
              </h4>
              <ul className="space-y-3">
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Schedule a Demo
                  </button>
                </li>
                <li>
                  <p className="text-gray-900 text-sm font-[600] font-satoshi mb-2">
                    Technology Partner
                  </p>
                  <span className="inline-block bg-gray-900 text-white text-xs font-fustat px-3 py-1.5 rounded-md">
                    OpenAi
                  </span>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-gray-900 text-sm font-[600] mb-4 font-satoshi">
                Legal
              </h4>
              <ul className="space-y-3">
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Terms of Service
                  </button>
                </li>
                <li>
                  <button className="text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    Refund Policy
                  </button>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div>
              <h4 className="text-gray-900 text-sm font-[600] mb-4 font-satoshi">
                Social
              </h4>
              <ul className="space-y-3">
                <li>
                  <button className="flex items-center gap-2 text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    {/* LinkedIn Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    LinkedIn
                  </button>
                </li>
                <li>
                  <button className="flex items-center gap-2 text-gray-400 text-sm font-fustat hover:text-gray-700 transition-colors cursor-pointer bg-transparent border-none p-0">
                    {/* X (Twitter) Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.91-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                    X
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
